import {messagemain} from './messagemain'
import {messagenotify} from './messagenotify'

export const message = {
  messagemain,
  messagenotify
}



// WEBPACK FOOTER //
// ./src/api/gip/message/index.js